import React from 'react'

import TeamList from '../TeamList/TeamList'

import './OurTeam.css'

const OurTeam = () => (
  <div className="fmbm-our_team wow fadeIn">
    <div className="fmbm-our_team__header">
      <h1 className="fmbm-our_team__title">Our team</h1>
      <p className="fmbm-our_team__description">
        Our mission is to empower not only businesses, but other Makers, to
        build better products, using the technology we create. Allowing them to
        focus on the problem they are trying to solve.
      </p>
    </div>
    <TeamList />
  </div>
)

export default OurTeam



// WEBPACK FOOTER //
// ./src/Components/OurTeam/OurTeam.js